/**
 * @file
 * VUE Filters
 * Used in library: vue
 *
 * Use this file to register filters
 * See https://vuejs.org/v2/guide/filters.html
 * This configuration will be set in @/bootstrap/app.ts
 */

import {FilterOptions} from 'simpli-web-sdk'
import * as Helper from '@/helpers'

/**
 * VUE Filters
 */
export const filters: FilterOptions = {
  orDash(val?: string): string {
    return (val !== undefined) ? val : '-'
  },

  degreesMinutesAndSeconds(val?: string): string {
    const absolute = Math.abs(Number(val))
    const degrees = Math.floor(absolute)
    const minutesNotTruncated = (absolute - degrees) * 60
    const minutes = Math.floor(minutesNotTruncated)
    const seconds = Math.floor((minutesNotTruncated - minutes) * 600) / 10

    return `${degrees}º ${minutes}' ${seconds}"`
  },

  latitude(val?: string): string {
    if (!val) return ''

    const latitude = filters.degreesMinutesAndSeconds(val)
    const latitudeCardinal = Math.sign(Number(val)) >= 0 ? 'N' : 'S'

    return `${latitude} ${latitudeCardinal}`
  },

  longitude(val?: string): string {
    if (!val) return ''

    const longitude = filters.degreesMinutesAndSeconds(val)
    const longitudeCardinal = Math.sign(Number(val)) >= 0 ? 'E' : 'W'

    return `${longitude} ${longitudeCardinal}`
  },

  percentage(val?: string): string {
    return val === undefined ? '' : `${Number(val).toFixed(2).replace('.', ',')}%`
  },
}
